/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: kgnuU3lABlxV
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicParagraph.module.css"; // plasmic-import: kgnuU3lABlxV/css

createPlasmicElementProxy;

export const PlasmicParagraph__VariantProps = new Array();

export const PlasmicParagraph__ArgProps = new Array("p");

const $$ = {};

function PlasmicParagraph__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <p
            className={classNames(
              projectcss.all,
              projectcss.p,
              projectcss.__wab_text,
              sty.p__eBjmB
            )}
          >
            {"Enter some text"}
          </p>
        ),

        value: args.p
      })}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicParagraph__ArgProps,
          internalVariantPropNames: PlasmicParagraph__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicParagraph__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicParagraph";
  } else {
    func.displayName = `PlasmicParagraph.${nodeName}`;
  }
  return func;
}

export const PlasmicParagraph = Object.assign(
  // Top-level PlasmicParagraph renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicParagraph
    internalVariantProps: PlasmicParagraph__VariantProps,
    internalArgProps: PlasmicParagraph__ArgProps
  }
);

export default PlasmicParagraph;
/* prettier-ignore-end */
